import { createSelector } from '@reduxjs/toolkit';

import { selectCommercialPriceTypeOptions } from './selectCommercialPriceTypeOptions';
import { selectCommercialPriceTypeValue } from './selectCommercialPriceTypeValue';

const DEFAULT_LABEL = 'Тип цены';

export const selectCommercialPriceTypeLabel = createSelector(
  [selectCommercialPriceTypeValue, selectCommercialPriceTypeOptions],
  (value, options) => {
    const match = options.find(option => option.value === value);

    return match ? match.label : DEFAULT_LABEL;
  },
);
